import { useCallback, useContext, useEffect, useState } from "react";
import Popup1 from "../../../components/UI/Client/CompanyProfile/popup1";
import Popup2 from "../../../components/UI/Client/CompanyProfile/popup2";
import Popup3 from "../../../components/UI/Client/CompanyProfile/popup3";
import { UserContext } from "../../../context";
import classes from "./profile.module.css";
import Loop2 from "../../../assets/loader/loop2.svg";
import { companyProfile } from "../../../services/clientCalls";
import { errorHandler } from "../../../utils";
import { talentGetCompanyProfile } from "../../../services/talentCalls";
import { useParams } from "react-router";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";
import ProfileHero from "../../../components/UI/Client/CompanyProfile/ProfileHero";
import GeneralInfoCard from "../../../components/UI/Client/CompanyProfile/GeneralInfoCard";
import AboutCard from "../../../components/UI/Client/CompanyProfile/AboutCard";
import ClassificationCard from "../../../components/UI/Client/CompanyProfile/ClassificationCard";
import SocialLinksCard from "../../../components/UI/Client/CompanyProfile/SocialLinksCard";
import ProfileCompletionCard from "../../../components/UI/Client/CompanyProfile/ProfileCompletionCard";

const CompanyProfile = ({ type }) => {
  const [data, setData] = useState({});
  const [load, setLoad] = useState(true);
  const { id } = useParams();
  const getCompanyProfile = useCallback(async () => {
    setLoad(true);
    try {
      const res = await companyProfile();
      if(res?.data?.data?.client){
        setData(res.data.data.client);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  }, []);
  const getCompanyProfileByTalent = async () => {
    setLoad(true);
    try {
      const res = await talentGetCompanyProfile(id);
      setData(res.data.data.client);
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (type === "client") {
      getCompanyProfile();
    }
    if (type === "talent") {
      getCompanyProfileByTalent();
    }
  }, []);

  return (
    <div className={classes.main}>
      {load && <FullScreenLoader />}
      <ProfileHero data={data} />
      <section className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-6">
        {/* Left Column */}
        <div className="order-2 lg:order-1 space-y-6">
          <GeneralInfoCard
            profileData={data}
            getCompanyProfile={getCompanyProfile}
          />
          <AboutCard profileData={data} getCompanyProfile={getCompanyProfile} />
        </div>

        {/* Right Column */}
        <div className="order-1 lg:order-2 space-y-6">
          <ProfileCompletionCard
            profileData={data}
            getCompanyProfile={getCompanyProfile}
          />
          <ClassificationCard
            profileData={data}
            getCompanyProfile={getCompanyProfile}
          />
          <SocialLinksCard
            profileData={data}
            getCompanyProfile={getCompanyProfile}
          />
        </div>
      </section>
    </div>
  );
};

export default CompanyProfile;
